import { render } from "./DbfieldsTableView.vue?vue&type=template&id=678328df"
import script from "./DbfieldsTableView.vue?vue&type=script&lang=js"
export * from "./DbfieldsTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__